import React from 'react';
import { reduxForm, Field } from 'redux-form';
import InputField from '../../../InputField';
import SelectSearchField from '../../../SelectSearchField';
import SelectField from '../../../SelectField';
import FormError from '../../../FormError';
import { BIG_PAGE_SIZE } from '../../../../constants';
import states from 'helpers/states';

let ChangeMdnModalForm = ({
  handleSubmit,
  error,
  quickSubs,
  isPurchasePage,
}) => {
  const showSubsInput = quickSubs.length >= BIG_PAGE_SIZE;
  const subsOptions = !showSubsInput
    ? quickSubs.map((sub) => ({
        name: `${sub.id} | ${sub.first_name} ${sub.last_name}`,
        value: sub.id,
      }))
    : [];

  return (
    <form onSubmit={handleSubmit}>
      {isPurchasePage && (
        <React.Fragment>
          {!showSubsInput && (
            <Field
              component={SelectSearchField}
              name="sub_id"
              label="Quick Subscription"
              options={subsOptions}
              placeholder="Select subscription"
              hideEmptyWhenHasValue={true}
              formName="changeMdnModal"
              smallHeight
            />
          )}
          {showSubsInput && (
            <Field
              component={InputField}
              name="sub_id"
              label="Quick Subscription Id"
            />
          )}
        </React.Fragment>
      )}

      <Field component={InputField} name="address1" label="Address Line 1" />
      <Field component={InputField} name="city" label="City" />
      <Field
        component={SelectField}
        name="state"
        label="State"
        empty="Choose a state"
        options={states.map((state) => [state.abbreviation, state.name])}
      />
      <Field component={InputField} name="zip_code" label="Zip Code" />
      {error && <FormError error={error} />}
      <br />
      <button className="btn btn-primary">Change MDN</button>
    </form>
  );
};

const validate = (values, { isPurchasePage }) => {
  let errors = {};

  if (isPurchasePage && !values.sub_id) {
    errors.sub_id = 'Required';
  }

  const { sub_id, ...addressValues } = values;
  const needToChangeAddress = !!Object.values(addressValues).find((value) =>
    value.trim(),
  );
  if (needToChangeAddress) {
    const fields = ['address1', 'city', 'state', 'zip_code'];
    fields.forEach((field) => {
      if (!values[field]) {
        errors[field] = 'Required';
      }
    });
  }

  return errors;
};

ChangeMdnModalForm = reduxForm({
  form: 'changeMdnModal',
  validate,
})(ChangeMdnModalForm);

export default ChangeMdnModalForm;
